/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import { compose, setDisplayName, setPropTypes } from 'recompose'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import DocumentDisplay from 'compositions/Document'
import DocumentNavigationShape from 'shapes/DocumentNavigation'
import DocumentShape from 'shapes/Document'
import barPlotNavigationShape from 'shapes/BarPlotNavigation'

const DocsTemplate = compose(
  setDisplayName('DocsTemplate'),
  setPropTypes({
    data: PropTypes.shape({
      doc: DocumentShape.raw,
      docs: DocumentNavigationShape.raw,
      barPlots: barPlotNavigationShape.raw,
    }),
  })
)(DocumentDisplay)

export default DocsTemplate

export const query = graphql`
  query($slug: String!) {
    barPlots: allImageSharp(
      filter: { fields: { plotType: { eq: "Bar" } } }
      sort: { fields: [fields___sortOrder] }
    ) {
      ...BarPlotNav
    }

    doc: markdownRemark(fields: { slug: { eq: $slug } }) {
      ...Document
    }

    docs: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/data/docs/" } }
      sort: { fields: [fields___sortOrder] }
    ) {
      ...DocumentNav
    }
  }
`
